import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { WhatsappNotifierService } from './whatsapp-notifier.service';
import { threadListOutGoingEvents } from '@skyeng/libs/communications/widgets/thread-list';
import { DecorateUntilDestroy, takeUntilDestroyed } from '@skyeng/libs/shared/rxjs';
import { DomPortal } from '@angular/cdk/portal';

@DecorateUntilDestroy()
@Component({
  selector: 'crm-whatsapp-notifier',
  templateUrl: './whatsapp-notifier.component.html',
  styleUrls: ['./whatsapp-notifier.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WhatsappNotifierComponent implements AfterViewInit, OnInit, OnDestroy {
  unreadCount$: Observable<number> = threadListOutGoingEvents.unreadCount.listen();
  isOpen = false;

  @ViewChild('domPortalContent') domPortalContent: ElementRef<HTMLElement>;
  domPortal: DomPortal<HTMLElement>;

  constructor(
    private router: Router,
    private elementRef: ElementRef,
    private whatsappNotifierService: WhatsappNotifierService,
  ) {}

  ngAfterViewInit(): void {
    this.domPortal = new DomPortal(this.domPortalContent);
  }

  ngOnInit(): void {
    this.initOpenThreadSubscription();
    this.initThreadListSubscription();
  }

  private initOpenThreadSubscription(): void {
    threadListOutGoingEvents.openThread
      .listen()
      .pipe(takeUntilDestroyed(this))
      .subscribe(openThreadEvent => {
        const personId =
          this.whatsappNotifierService.getPersonIdByThreadId(openThreadEvent.id) ||
          openThreadEvent.messageLast.userFrom.id;
        if (personId) {
          this.router.navigate(['/', 'persons', personId, 'communications', 'messenger', openThreadEvent.id]);
        }
      });
  }

  private initThreadListSubscription(): void {
    threadListOutGoingEvents.threadList
      .listen()
      .pipe(takeUntilDestroyed(this))
      .subscribe(threadList => {
        this.whatsappNotifierService.mapThreadIds(threadList);
      });
  }

  @HostListener('document:click', ['$event'])
  documentClick(event): void {
    if (document.contains(event.target) && !this.elementRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  ngOnDestroy(): void {}
}
